import PromotionModal from './PromotionModal';
export default PromotionModal;
